<template>
    <div>
        <div class="card">
            <div class="card-header animated fadeInRightBig" >
                <div class="card-title">Usuário</div>      
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <label><span class="required">*</span> Nome:</label>
                        <input type="text" class="form-control" name="name" v-model="user.name" id="name">
                    </div>
                    <div class="col-md-6">
                        <label><span class="required">*</span> Email</label>
                        <input type="email" class="form-control" name="email" v-model="user.email" id="email">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <label><span class="required">*</span> Senha</label>
                        <input type="password" name="password" class="form-control" id="password" v-model="user.password">
                    </div>
                    <div class="col-md-6">
                        <label><span class="required">*</span> Acesso Rápido</label>
                        <input type="number" class="form-control" v-model="user.quick_access" v-mask="'####'">
                    </div>
                </div>

                <hr class="m-t-md m-b-md">

                <div class="row">
                    <div class="col-md-12">
                        <input type="file" name="photo" id="photo">
                    </div>
                </div>

                <hr>

                <div class="block text-right">
                    <router-link to="/users" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <p><span class="required">*</span> Campos Obrigatórios</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: {
                    name: '',
                    email: '',
                    password: '',
                    quick_access: ''
                }
            }
        },
        methods: {
            save: function () {
                const self = this;

                if(self.user.id) return self.edit();

                const api = this.$store.state.api + 'users';

                let fd = self.makeFormData();

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Usuário cadastrado com sucesso`, 'success');
                        this.$router.push('/users');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            edit: function () {
                const self = this;
                const api = self.$store.state.api + 'users/' + self.user.id;

                let fd = self.makeFormData();

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Usuário cadastrado com sucesso`, 'success');
                        this.$router.push('/users');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            makeFormData: function(){
                const self = this;

                let fd  = new FormData();

                let photo = document.getElementById('photo').files[0];
                if(photo){
                    fd.append('photo', photo);
                }

                fd.append('name', self.user.name);
                fd.append('email', self.user.email);
                if(self.user.password){
                    fd.append('password', self.user.password);
                }
                fd.append('quick_access', self.user.quick_access);

                if(self.user.id) {
                    fd.append('id', self.user.id);
                    fd.append('_method', 'PUT');
                }

                
                return fd;
            },
            getUser: function(id){
                let self = this;
                let api  = self.$store.state.api + 'users/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.user = response.data.data[0];
                    })
                    .catch((error) => {
                        self.errors = error.response.data;
                        self.$message(null, self.errors, 'error');
                    });
            },
        },
        mounted: function(){
            const self = this;

            let id   = self.$route.params.id;
            if(id) {
                self.getUser(id);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/User/User.vue